module.exports = __webpack_public_path__ + "static/img/speciality-header.af37a3f4.png";